import React from 'react';

import * as S from './styles';

function Content({ children }) {
  return <S.Content>{children}</S.Content>;
}

export default Content;
